<template>
  <div class="container pt-3 pb-1 step-0">
    <div class="row">
      <div class="col-12">
        <p class="lora h3">Termin pobytu i pokój</p>
      </div>
    </div>

    <div class="row py-2">
      <div class="col-auto my-1">
        <DateRange :min-date="minDate" :schema="schema.dateRange" @change="reset" />
      </div>

      <div class="col my-1 col-amount">
        <AmountPicker id="amount-picer" :schema="schema" @change="reset" />
      </div>
    </div>

    <div v-if="!formFilled" class="alert">Proszę wybrać termin oraz wprowadzić ilość osób.</div>

    <div v-else>
      <div
        v-for="(occupancy, occupancyIndex) in schema.occupancy.$items"
        :key="'occupancy_' + occupancyIndex"
        :ref="'occupancy_' + occupancyIndex"
      >
        <template
          v-if="
            occupancyIndex === 0 || (availableRooms[occupancyIndex - 1] && availableRooms[occupancyIndex - 1].length)
          "
        >
          <div class="occupancy-info">
            <span class="room-number">Pokój {{ occupancyIndex + 1 }}</span>

            <span class="adults">dorośli: {{ occupancy.$item.numberOfAdults.$model }}</span>

            <span v-if="occupancy.$item.numberOfChildren3.$model" class="children3">
              dzieci do lat 3: {{ occupancy.$item.numberOfChildren3.$model }}
            </span>

            <span v-if="occupancy.$item.numberOfChildren12.$model" class="children12">
              dzieci 4-12 lat: {{ occupancy.$item.numberOfChildren12.$model }}
            </span>
          </div>

          <div v-if="occupancyIndex <= currentOccupancyIndex || !!occupancy.$item.room.id.$model" class="room-list">
            <div v-if="!availableRooms[occupancyIndex].length" class="alert">
              Brak wyników spełniających kryteria wyszukiwania.
            </div>
            <div v-else>
              <Room
                v-for="(room, roomIndex) in availableRooms['' + occupancyIndex]"
                :key="'room_' + roomIndex"
                class="row"
                :room="room"
                :occupancy="occupancy.$item"
                :schema="schema"
                @selected="roomSelected"
                @unselected="roomUnselected(occupancyIndex)"
              />
            </div>
          </div>

          <div v-else class="alert">Proszę wybrać pokoje wyżej.</div>
        </template>
      </div>

      <div v-if="schema.occupancy.$items.length > 1 && selectOfferTypesVisible" ref="chooseOfferType">
        <div class="occupancy-info">Oferta</div>
        <OfferTypes :schema="schema" @selected="offerTypeSelected" />
      </div>
    </div>
  </div>
</template>

<script>
import DateRange from '@/components/core/DateRange';
import AmountPicker from './AmountPicker/AmountPicker';
import OfferTypes from './OfferTypes';
import Room from './Room';
import roomService from '@/services/room.service';

export default {
  components: { AmountPicker, DateRange, OfferTypes, Room },
  props: {
    schema: { type: Object, required: true }
  },
  data() {
    return {
      minDate: new Date().toISOString(),
      formFilled: false,
      availableRooms: {},
      currentOccupancyIndex: 0
    };
  },
  computed: {
    selectOfferTypesVisible() {
      const numberOfSelectedRooms = this.schema.occupancy.$items.filter(item => !!item.$item.room.id.$model).length;
      return numberOfSelectedRooms === this.schema.occupancy.$items.length;
    }
  },
  methods: {
    reset() {
      this.currentOccupancyIndex = 0;
      this.$set(this, 'availableRooms', {});
      this.schema.occupancy.$items.forEach(occupancy => {
        occupancy.$item.room.$setData({ id: 0, name: '', additions: [] });
      });
      this.schema.offer.$setDefault();
      this.search(0);
    },
    search(index) {
      const $vm = this;
      if (this.schema.dateRange.start.$model && this.schema.dateRange.end.$model) {
        this.$set($vm.availableRooms, '' + index, []);
        const occupancy = this.schema.occupancy.$items[index].$item;

        this.formFilled = true;
        const query = {
          start: this.schema.dateRange.start.$model,
          end: this.schema.dateRange.end.$model,
          adults: occupancy.numberOfAdults.$model,
          children3: occupancy.numberOfChildren3.$model,
          children12: occupancy.numberOfChildren12.$model,
          rooms: this.schema.occupancy.$items.map(occupancy => occupancy.$item.room.id.$model).filter(id => !!id)
        };
        return roomService.search(query).then(rooms => {
          $vm.$set($vm.availableRooms, '' + index, rooms);
        });
      }
      return Promise.resolve();
    },
    roomSelected() {
      if (this.schema.occupancy.$items.length === 1) {
        return this.$emit('completed');
      }
      this.setCurrentOccupancyIndex();
    },
    roomUnselected(index) {
      this.currentOccupancyIndex = index;
      if (index == 0) {
        this.schema.offer.$setDefault();
      }
      this.schema.occupancy.$items[index].$item.offer.$setDefault();
      this.search(index);
    },
    offerTypeSelected(offerType) {
      this.schema.occupancy.$items.forEach(occupancy => {
        const price = occupancy.$item.room.prices.$items.find(price => price.$item.id.$model === offerType.id);
        occupancy.$item.offer.$setData(price.$item.$model);
      });
      this.schema.offer.$setData({ ...offerType, price: null });
      return this.$emit('completed');
    },
    setCurrentOccupancyIndex() {
      for (let occIndex = 0; occIndex < this.schema.occupancy.$items.length; occIndex++) {
        const occ = this.schema.occupancy.$items[occIndex];
        if (!occ.$item.room.id.$model) {
          this.currentOccupancyIndex = occIndex;
          this.$nextTick(() => {
            if (this.$refs['occupancy_' + occIndex]) {
              const element = this.$refs['occupancy_' + this.currentOccupancyIndex][0];
              this.$scrollTo(element);
            }
          });
          return this.search(occIndex);
        }
      }
      this.$nextTick(() => {
        if (this.$refs.chooseOfferType) {
          this.$scrollTo(this.$refs.chooseOfferType);
        }
      });
      return Promise.resolve();
    }
  },
  mounted() {
    this.setCurrentOccupancyIndex();
    this.reset();
  }
};
</script>
